import { formatDateLocal } from '@/lib/timeFormatUtils';

export type NoticeScope = 'permanent' | 'date' | 'weekday';

export interface EstablishmentNotice {
  id: string;
  establishmentId: string;
  message: string;
  scope: NoticeScope;
  specificDate: string | null; // yyyy-MM-dd
  weekday: number | null; // 0 = dimanche … 6 = samedi
  requireAcknowledgement: boolean;
  isActive: boolean;
}

export const NOTICE_MAX_LENGTH = 500;

export const WEEKDAY_LABELS = [
  'Dimanche',
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
];

/**
 * Sélectionne la note à afficher pour une date donnée.
 * Priorité : date précise > jour de semaine > permanent.
 * Les notes inactives sont ignorées. Une seule note est affichée.
 */
export function selectApplicableNotice(
  notices: EstablishmentNotice[] | undefined | null,
  date: Date | undefined | null
): EstablishmentNotice | null {
  if (!notices || notices.length === 0) return null;
  const active = notices.filter((n) => n.isActive && n.message.trim() !== '');
  if (active.length === 0) return null;

  if (date) {
    const iso = formatDateLocal(date);
    const exact = active.find((n) => n.scope === 'date' && n.specificDate === iso);
    if (exact) return exact;

    const weekday = date.getDay();
    const recurring = active.find((n) => n.scope === 'weekday' && n.weekday === weekday);
    if (recurring) return recurring;
  }

  return active.find((n) => n.scope === 'permanent') ?? null;
}
